import React, { Component } from "react";
import moment from "moment";
import { propertyUtil } from "views/Pma/PropertyUtil";

const getRepresentedLabel = (prop) => {
  if (prop.isBuyingAgent && prop.isSellingAgent) {
    return "Buyer & Seller";
  }
  if (prop.isBuyingAgent) {
    return "Buyer";
  }
  if (prop.isSellingAgent) {
    return "Seller";
  }

  const footerText = prop.footerText1 || "";
  const hasBuyers =
    footerText.includes("Buyer") || footerText.includes("Buyers");
  const hasSellers =
    footerText.includes("Seller") || footerText.includes("Sellers");

  if (hasBuyers && hasSellers) {
    return "Buyer & Seller";
  }
  if (hasBuyers) {
    return "Buyer";
  }
  if (hasSellers) {
    return "Seller";
  }

  return "-";
};

class HighlightRow extends Component {
  render() {
    const {
      prop,
      index,
      areaID,
      handleSelect,
      openEditDialogFn,
      showButton,
      showSelectButton,
      isSelectedTable,
    } = this.props;
    //  console.log("highlightrow", this.props);
    const getMonthAndYearString = (inputTime) => {
      try {
        if (!inputTime || inputTime === "-") {
          return <p>-</p>;
        } else {
          let month = moment(inputTime).format("MMM");
          let day = moment(inputTime).format("D");
          let year = moment(inputTime).format("YYYY");
          return (
            <p>
              {month} {day},{" "}
              {Number(year) === 2021 ? (
                <span className="bolded-year">{year}</span>
              ) : (
                year
              )}
            </p>
          );
        }
      } catch (err) {
        return "";
      }
    };
    const { formatSuffix } = propertyUtil;
    const represented = getRepresentedLabel(prop);

    // Helper function to format status and price for display
    const formatStatusAndPrice = () => {
      const status = prop.status || "";
      const bannerText2 = prop.bannerText2 || "";

      // Determine which price to use based on status
      let price = "";
      if (status === "Sold") {
        price = prop.salePrice;
      } else if (["Active", "Pending", "Contingent"].includes(status)) {
        price = prop.listPrice;
      }

      // Format price with dollar sign and commas
      const formattedPrice = price ? `$${Number(price).toLocaleString()}` : "";

      // Return bannerText2 with formatted price
      return formattedPrice ? `${bannerText2} ${formattedPrice}` : bannerText2;
    };

    return (
      <div
        key={`${prop.address} ${prop.listPrice} ${prop.saleDate} ${index}`}
        className={`prop-highlight-tr ${
          prop.isSystemSelected ? "selected-prop" : ""
        }`}
      >
        <div className="highlight-td">
          {isSelectedTable ? (
            showButton && <div className="highlight-td">{index + 1}</div>
          ) : (
            <div className="highlight-td">{prop.status || "-"}</div>
          )}
        </div>

        <div className="highlight-td">
          {/* Show "Selected" text for selected properties table */}
          {isSelectedTable ? (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div className="selected-text">Selected</div>
              <button
                className="remove-select-btn"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  border: "1px solid #dc3545",
                  borderRadius: "50%",
                  width: "20px",
                  height: "20px",
                  background: "#fff",
                  color: "#dc3545",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0",
                }}
                title="Remove Property"
                onClick={() => handleSelect(prop, false)}
              >
                ×
              </button>
            </div>
          ) : (
            /* Plus icon for unselected properties table */
            <button
              className="plus-select-btn"
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                border: "1px solid #4e85af",
                borderRadius: "50%",
                width: "28px",
                height: "28px",
                background: "#fff",
                color: "#4e85af",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              title="Select Property"
              onClick={() => handleSelect(prop, true)}
            >
              +
            </button>
          )}
        </div>

        <div className="highlight-td">{prop.bannerText1}</div>
        <div className="highlight-td">{formatStatusAndPrice()}</div>
        <div className="highlight-td">{represented}</div>
      </div>
    );
  }
}

export default HighlightRow;
